import {Component, OnInit} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {Router} from '@angular/router';

@Component({
    selector: 'app-ai-form-creator',
    templateUrl: './ai-form-creator.component.html',
    styleUrls: ['./ai-form-creator.component.scss']
})
export class AiFormCreatorComponent implements OnInit {
    gradioUrl: SafeResourceUrl;
    isLoading: boolean;
    aiText: string;

    constructor(private sanitizer: DomSanitizer, private router: Router) {
        this.isLoading = true;
        this.aiText = '';
        // Direct Gradio URL format - επιτρέπει iframe embedding
        this.gradioUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
            'https://koromama-uowm.hf.space'
        );
    }

    ngOnInit() {
    }

    onIframeLoad() {
        this.isLoading = false;
    }

    async transferToFormCreator() {
        if (this.aiText && this.aiText.trim().length > 0) {
            localStorage.setItem('aiGeneratedContent', this.aiText.trim());
            await this.router.navigate(['/home/custom-form-creator'], {
                queryParams: { fromAI: true }
            });
        }
    }
}
